import { createFileRoute, redirect } from '@tanstack/react-router'
import { ProjectsListPage } from '@/features/city-clerk/projects-list'
import { getProjectsDataByCityId } from '@/features/city-clerk/projects-list'
import { PLACEHOLDER_IDS } from '@/components/layout/sidebar/constants'
import { queryKeys } from '@/lib/query-keys'

export const Route = createFileRoute('/(app)/city-clerk/$id/projects/')({
  beforeLoad: ({ context }) => {
    if (context.auth.loading) return
    if (!context.auth.userInfo?.uiCapabilities?.projectsView) {
      throw redirect({ to: '/access-denied' })
    }
  },
  loader: ({ context: { queryClient }, params: { id } }) => {
    if (!id || id === PLACEHOLDER_IDS.NO_CITY_CLERK) return
    return queryClient.fetchQuery({
      queryKey: queryKeys.projects.list(id, 1, 5),
      queryFn: () => getProjectsDataByCityId(id, 1, 5),
    })
  },
  component: ProjectsListPage,
})
